var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header',{attrs:{"page_name":_vm.$t('navigation.headerTitles.deleted'),"show_usermenu":""}}),_c('status-grid',{attrs:{"gridData":_vm.getDeletedTaskData,"gridType":"deleted"},on:{"refresh":_vm.sendForData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }